import React, { useEffect } from "react";
import "./CompanyBio.css";
import linkedinLogo from "../../assets/linkdin.png";
// import companyImage from '../../assets/bg.gif';
import About from "../Aboute/Aboute";
import { useTranslation } from "react-i18next";

const CompanyBio = () => {
  const { t } = useTranslation();
  const bioServices = t("bio_services_list", { returnObjects: true }) || [];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="company-bio">
      <div className="bio-split">
        {/* Left side: content */}
        <div className="bio-content">
          <div className="bio-container">
            <h1 className="bio-title">{t("bio_title")}</h1>
            <p className="bio-description">{t("bio_description")}</p>
            <div className="bio-services">
              <p>{t("bio_services_title")}</p>
              <ul>
                {Array.isArray(bioServices) &&
                  bioServices.map((service, index) => (
                    <li key={index}>{service}</li>
                  ))}
              </ul>
            </div>
            <p className="bio-tech">{t("bio_tech")}</p>
            <About />
            <a
              href="https://www.linkedin.com/company/codered-digital"
              className="bio-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit ELYX on LinkedIn"
            >
              <img
                src={linkedinLogo}
                alt="LinkedIn Logo"
                className="linkedin-icon"
              />
            </a>
          </div>
        </div>
        {/* Right side: optional image or animation */}
        {/* <div className="bio-media">
          <img src={companyImage} alt="ELYX Company" className="company-image" />
        </div> */}
      </div>
    </section>
  );
};

export default CompanyBio;
